/* ============================================================
   assets/int-fp-slide-filter.js          INTENTION — 2026-09-17
   FRAMED PRINT ONLY. Makes the gallery SWIPE show the same photos the
   thumbnail rail shows, and nothing else.

   ⚑ THE BUG THIS FIXES. Measured live on the draft, Dancing Cowboy, 400px:
   the rail had 3 thumbnails visible and 117 carrying `int-thumb-hidden`,
   while the Flickity gallery held all 120 slides as live cells, every one
   394px wide, a track 47,280px long. The first three cells happened to be
   the selected combination's three, so it looked right until a shopper
   swiped a fourth time and landed on another frame colour or frame size.
   Apparel never had this: assets/int-variant-gallery.js filters that
   gallery at the CELL level. This template filtered only the rail.

   ⚑ WHY IT READS THE RAIL RATHER THAN RE-MATCHING THE VARIANT.
   sections/product-framedprint.liquid already decides which photos belong
   to the current combination, in apply(), and that rule is subtle: it has
   been corrected twice (the 2026-09-13 note about Paper Color being
   overwritten by the size, and the 2026-09-13 note about collapsing double
   spaces). Duplicating it here would create a second copy to keep in step.
   So this file does not match anything. It reads which thumbnails are NOT
   hidden and makes the gallery hold exactly those, keyed on
   data-media-select == data-media-id. The rail is the source of truth, and
   the swipe cannot disagree with it by construction.

   ⚑ MECHANISM: Flickity remove() and append(), the same pair
   assets/int-variant-gallery.js uses on apparel. A cell cannot be hidden
   with display:none instead — Flickity keeps it in the cell list at zero
   width, so a swipe still lands on it and shows nothing.

   remove() detaches the element, so every slide is captured in a map at
   boot, before anything is removed, and re-appended from that map when the
   combination changes. Do not drop that map.

   EVERY WIDTH. The rail filter runs on desktop too, so this must not be
   gated on a breakpoint.
   ============================================================ */
(function () {
  'use strict';
  if (window.__intFpSlideFilter) return;
  window.__intFpSlideFilter = true;

  var ALL = null;          /* media id -> slide element, captured once */
  var busy = false;

  function flk() {
    var F = window.Flickity || (window.themeVendor && window.themeVendor.Flickity);
    var ss = document.querySelector('[data-product-slideshow]');
    return (ss && F && F.data) ? F.data(ss) : null;
  }

  function capture() {
    if (ALL) return ALL;
    var slides = document.querySelectorAll('[data-media-slide][data-media-id]');
    if (!slides.length) return null;
    ALL = {};
    for (var i = 0; i < slides.length; i++) ALL[String(slides[i].getAttribute('data-media-id'))] = slides[i];
    return ALL;
  }

  /* The ids the rail is currently showing, in rail order. */
  function wanted() {
    var out = [];
    var thumbs = document.querySelectorAll('[data-slideshow-thumbnail][data-media-select]');
    for (var i = 0; i < thumbs.length; i++) {
      var t = thumbs[i];
      if (t.classList.contains('int-thumb-hidden')) continue;
      if (t.style && t.style.display === 'none') continue;
      var id = String(t.getAttribute('data-media-select'));
      if (id && out.indexOf(id) === -1) out.push(id);
    }
    return out;
  }

  function cellIds(f) {
    var out = [];
    for (var i = 0; i < f.cells.length; i++) {
      var el = f.cells[i].element;
      if (el) out.push(String(el.getAttribute('data-media-id')));
    }
    return out;
  }

  function sync() {
    if (busy) return;
    var f = flk();
    if (!f || !f.cells || !f.cells.length) return;
    if (!capture()) return;

    var want = wanted();
    /* ⛑ A rail that is mid-rebuild can report zero. Never empty the gallery. */
    if (!want.length) return;

    var have = cellIds(f);
    if (have.length === want.length && have.join(',') === want.join(',')) return;

    var add = [], i;
    for (i = 0; i < want.length; i++) {
      if (have.indexOf(want[i]) === -1 && ALL[want[i]]) add.push(ALL[want[i]]);
    }
    var drop = [];
    for (i = 0; i < f.cells.length; i++) {
      var el = f.cells[i].element;
      if (el && want.indexOf(String(el.getAttribute('data-media-id'))) === -1) drop.push(el);
    }
    /* Nothing to do, or the change would leave no cell at all. */
    if (!add.length && !drop.length) return;
    if (!add.length && drop.length >= f.cells.length) return;

    /* ⚑ WHICH PHOTO IS SHOWING AFTERWARDS IS NOT AUTOMATIC. Flickity's own
       remove() just shifts selectedIndex by arithmetic. Measured before this
       block existed: clicking a frame colour left the shopper on index 2, the
       corner crop, instead of the new colour's hero. So the media id showing
       now is captured first, and restored if it survived the swap. If it did
       not, the rail's FIRST visible thumbnail is the hero for this
       combination, so that is what gets selected. */
    var selEl = document.querySelector('[data-media-slide].is-selected');
    var keepId = selEl ? String(selEl.getAttribute('data-media-id')) : null;

    busy = true;
    try {
      /* Append first, THEN remove the old ones, so the gallery is never empty
         for a frame. Same order as apparel. */
      if (add.length) {
        for (i = 0; i < add.length; i++) add[i].style.removeProperty('display');
        f.append(add);
      }
      if (drop.length) f.remove(drop);
      if (f.cells.length) {
        var target = 0;
        if (keepId) {
          var now = cellIds(f);
          var at = now.indexOf(keepId);
          if (at > -1) target = at;
        }
        f.select(target, false, true);
      }
      if (f.resize) f.resize();
    } catch (e) {
      /* A gallery that failed to filter is still a working gallery. */
    }
    busy = false;
  }

  function schedule() { setTimeout(sync, 0); setTimeout(sync, 160); }

  /* The rail's own filter runs on variant change, on its assert loop and on
     its pre-paint observer, so rather than guess its timing, watch the rail
     for the class it toggles. */
  function watchRail() {
    var holder = document.querySelector('.media__thumb__holder');
    if (!holder || holder.__intFpWatched) return !!holder;
    holder.__intFpWatched = true;
    var t = null;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(sync, 60);
    }).observe(holder, { subtree: true, attributes: true, attributeFilter: ['class', 'style'], childList: true });
    return true;
  }

  document.addEventListener('variant:change', schedule, false);
  document.addEventListener('int:gallery:settled', schedule, false);
  document.addEventListener('change', function (e) {
    if (e.target && /^options\[/.test(e.target.name || '')) schedule();
  }, true);

  (function poll(waited) {
    watchRail();
    sync();
    if (waited < 15000) setTimeout(function () { poll(waited + 400); }, 400);
  })(0);
})();
